<p-table
  [value]="tableData"
  [rows]="rowsPerPage || paginator?.per_page"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  [columns]="tableHeader"
  styleClass="p-datatable-customers  p-datatable-responsive-demo"
  [paginator]="frontendPaginator"
  [(selection)]="selectedRows"
  (onRowSelect)="onRowSelect()"
  (selectAllChange)="onRowSelect()"
>
  <ng-template pTemplate="caption">
    <ng-content select="[filters]"></ng-content>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width: 3rem" *ngIf="enableRowSelect">
        <div (click)="onRowSelect()">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>
      <ng-container *ngFor="let col of columns">
        <th
          *ngIf="col?.roles?.includes(curentUser.data.role) || !col?.roles"
          [style]="col.options?.width"
        >
          {{ col.header | translate }}
        </th>
      </ng-container>

      <th style="width: 8rem" *ngIf="options.showSwitch">
        <div class="flex justify-content-center align-items-center">
          {{
            (options.switchText | translate) || ('LAYOUT.public' | translate)
          }}
        </div>
      </th>
      <th style="width: 5rem" *ngIf="options.showStatus">
        <div
          class="flex justify-content-center align-items-center hiddeTableStatus"
        >
          Status
        </div>
      </th>
      <th
        style="width: 8rem"
        *ngIf="options.showEdit || options.showDelete || options.showPreview"
      >
        <div class="flex justify-content-center align-items-center">
          {{ actionLabel }}
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-rowData
    let-i="rowIndex"
    let-columns="columns"
  >
    <tr>
      <td *ngIf="enableRowSelect" (click)="onRowSelect()">
        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
      </td>
      <ng-container *ngFor="let col of columns">
        <td *ngIf="col?.roles?.includes(curentUser.data.role) || !col?.roles">
          <span class="p-column-title">{{ col.header | translate }}</span>
          <span
            *ngIf="
              !col?.image &&
              !col?.url &&
              !col?.status &&
              !col?.date &&
              !col?.custom
            "
          >
            {{ rowData[col.field] }}</span
          >
          <span
            *ngIf="!rowData[col.field] && rowData[col.field] !== 0"
            class="text-xs bg-gray-200 border-round py-1 px-1"
          >
            No data
          </span>
          <ng-container *ngIf="col?.image">
            <img [src]="rowData[col.field]" style="width: 100%; height: auto" />
          </ng-container>
          <ng-container *ngIf="col?.date">
            <span>{{ rowData[col.field] | date: 'dd.MM.yyyy, HH:mm:ss' }}</span>
          </ng-container>
          <ng-container *ngIf="col?.custom && rowData[col.field]">
            <ng-container *ngIf="rowData[col.field].type === 'buttons'">
              <div class="flex">
                <button
                  *ngFor="let item of rowData[col.field].elements"
                  class="second-btn small-btn mr-2"
                  type="button"
                  [pTooltip]="item.tooltip"
                  tooltipPosition="top"
                  (click)="item.action($event, rowData)"
                >
                  <i [class]="item.icon"></i>
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="rowData[col.field].type === 'chip'">
              <div
                *ngIf="rowData[col.field].value"
                class="p-2 bg-red-50 text-red-400 w-fit text-xs border-round-md"
              >
                {{ rowData[col.field].value }}
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="col?.url">
            <a *ngIf="rowData['url']" [href]="rowData['url']" target="_blank">
              <span> {{ rowData[col.field] }}</span>
            </a>
          </ng-container>
        </td>
      </ng-container>

      <td *ngIf="options.showEdit || options.showDelete || options.showPreview">
        <span class="p-column-title">{{ actionLabel }}</span>
        <div class="w-btn-group">
          <ng-container *ngFor="let item of customOptions">
            <button
              class="second-btn small-btn mr-2"
              type="button"
              [pTooltip]="item.tooltip"
              tooltipPosition="top"
              (click)="item.action($event, rowData)"
            >
              <i [class]="item.icon"></i>
            </button>
          </ng-container>

          <ng-container *ngIf="options.showEdit">
            <ng-container
              *ngIf="editPath === 'post_template'; else elseTemplate"
            >
              <a
                class="second-btn small-btn mr-2"
                pTooltip="Edit"
                tooltipPosition="top"
                [routerLink]="[rowData[editPath], rowData.id]"
                [queryParams]="rowData.queryParams"
              >
                <i class="pi pi-pencil"></i>
              </a>
            </ng-container>
            <ng-template #elseTemplate>
              <a
                class="second-btn small-btn mr-2"
                pTooltip="Edit"
                tooltipPosition="top"
                [routerLink]="[editPath, rowData.id]"
              >
                <i class="pi pi-pencil"></i>
              </a>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="options.showPreview && !rowData.hidePreview">
            <button
              class="second-btn small-btn mr-2"
              type="button"
              pTooltip="Preview"
              tooltipPosition="top"
              (click)="previewRow($event, rowData)"
            >
              <i class="pi pi-eye"></i>
            </button>
          </ng-container>

          <ng-container *ngIf="options.showDelete">
            <button
              *ngIf="
                rowData.allowDelete === true ||
                rowData.allowDelete === undefined
              "
              class="second-btn small-btn"
              type="button"
              pTooltip="Delete"
              tooltipPosition="top"
              (click)="deleteRow($event, rowData.id)"
            >
              <i class="pi pi-trash"></i>
            </button>
          </ng-container>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="numberOfCols">No data available to display.</td>
    </tr>
  </ng-template>
</p-table>
<p-paginator
  #paginatorElement
  *ngIf="paginator"
  [first]="1"
  styleClass="mb-4"
  [rows]="rowsPerPage || paginator.per_page"
  [showJumpToPageDropdown]="true"
  [showPageLinks]="true"
  [totalRecords]="paginator.total"
  (onPageChange)="onPageChange($event)"
  [showPageLinks]="false"
  [rowsPerPageOptions]="[10, 50, 100, 250]"
></p-paginator>
<!-- * Confirmation popup -->
<p-confirmPopup styleClass="p-shadow-2"></p-confirmPopup>
